import {makeActionCreator} from '../utility'

export const FETCH_PROVINCE = 'FETCH_PROVINCE'
export const fetchProvince = makeActionCreator(FETCH_PROVINCE,'data')

export const FETCH_PROVINCE_SUCCESSFUL = 'FETCH_PROVINCE_SUCCESSFUL'
export const fetchProvinceSuccessful = makeActionCreator(FETCH_PROVINCE_SUCCESSFUL, 'data')



export const FETCH_DISTRICTS = 'FETCH_DISTRICTS'
export const fetchDistricts = makeActionCreator(FETCH_DISTRICTS,'data')

export const FETCH_DISTRICTS_SUCCESSFUL = 'FETCH_DISTRICTS_SUCCESSFUL'
export const fetchDistrictsSuccessful = makeActionCreator(FETCH_DISTRICTS_SUCCESSFUL, 'data')



export const FETCH_SECTORS = 'FETCH_SECTORS'
export const fetchSectors = makeActionCreator(FETCH_SECTORS,'data')

export const FETCH_SECTORS_SUCCESSFUL = 'FETCH_SECTORS_SUCCESSFUL'
export const fetchSectorsSuccessful = makeActionCreator(FETCH_SECTORS_SUCCESSFUL,'data')



export const FETCH_CELLS = 'FETCH_CELLS'
export const fetchCells = makeActionCreator(FETCH_CELLS,'data')

export const FETCH_CELLS_SUCCESSFUL = 'FETCH_CELLS_SUCCESSFUL'
export const fetchCellsSuccessful = makeActionCreator(FETCH_CELLS_SUCCESSFUL,'data')


export const FETCH_VILLAGES = 'FETCH_VILLAGES'
export const fetchVillages = makeActionCreator(FETCH_VILLAGES,'data')

export const FETCH_VILLAGES_SUCCESSFUL = 'FETCH_VILLAGES_SUCCESSFUL'
export const fetchVillagesSuccessful = makeActionCreator(FETCH_VILLAGES_SUCCESSFUL,'data')